import navigation from "./components/navigation";
import sliderBanners from "./components/sliderBanners";
import featuredProducts from "./components/featuredProducts";
import accordion from "./components/accordion";
import niceSelect from "./components/niceSelect";
import productPageSlider from "./components/productPageSlider";
import infinitescroll from "./components/infinitescroll";
import quantityField from "./components/quantityField";
import addToCartForm from "./components/addToCartForm";
import loadCartContents from "./app/util/loadCartContents";
import createAnAccount from "./components/createAnAccount";
import differentShipping from "./components/differentShipping";
import insectDropdown from "./components/insectDropdown";
import openProductPopup from "./components/openProductPopup";
import openStaffPopup from "./components/openStaffPopup";
import headerNotice from "./components/headerNotice";
import tooltip from "./components/tooltip";
import checkoutShippingForm from "./components/checkoutShippingForm";
import pageLoadDropdown from "./components/pageLoadDropdown";
import map from "./components/map";
import addressLookup from "./components/addressLookup";
import formCheckbox from "./components/formCheckbox";
import anchors from "./components/anchors";

import cookieBar from "../../../../vendor/smokeylemon/gdpr-basics/client/src/js/cookieBar";

import silverShop from "./app/app";
import signpad from "./components/signpad";


document.addEventListener("DOMContentLoaded", () => {

    cookieBar();

    navigation();
    accordion();
    sliderBanners();
    featuredProducts();
    niceSelect();
    productPageSlider();
    infinitescroll();
    quantityField();
    addToCartForm();
    createAnAccount();
    differentShipping();
    insectDropdown();
    openProductPopup();
    openStaffPopup();
    headerNotice();
    tooltip();
    checkoutShippingForm();
    pageLoadDropdown();
    map();
    addressLookup();
    signpad();
    formCheckbox();
    anchors();


});


window.addEventListener("load", () => {
    silverShop();

    loadCartContents();
});
